import { render, staticRenderFns } from "./UnsubscribesFragmentInvalidLink.vue?vue&type=template&id=1b0cf69b&scoped=true&"
import script from "./UnsubscribesFragmentInvalidLink.vue?vue&type=script&lang=js&"
export * from "./UnsubscribesFragmentInvalidLink.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribesFragmentInvalidLink.vue?vue&type=style&index=0&id=1b0cf69b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0cf69b",
  null
  
)

export default component.exports